import type { SelectOption } from './types';

export const isOptionGroup = <Option extends SelectOption, Group extends { options: Option[] }>(
  option: Option | Group
): option is Group => Array.isArray((option as Group).options);
